<template>
  <div class="results-block">
      <div v-if="paginationNeeded" class="row">
        <pagination 
                  :current-page="currentPage"
                  :total-pages="totalPages" @click="getPageOnClick">
                </pagination>
      </div>
      <div v-if="page_of_leads && page_of_leads.length">
          <div v-for="(lead, idx) in page_of_leads"  :key="lead + '_' + idx" class="lead-item">
            <lead-item :lead="lead" :idx="idx" :is_detailed="is_toggled(lead.id)"
                        @toggle-details="toggle_details(lead.id, true)"
                        @untoggle-details="toggle_details(lead.id, false)">
            </lead-item>
            <lead-item-details :lead="lead" :idx="idx" v-if="is_toggled(lead.id)"></lead-item-details>
          </div>
      </div>
      <div class="row" style="display: flex;" v-else>
        <h5 style="margin: auto;" class="light">Pas de données.</h5>
      </div>
      <div v-if="paginationNeeded" class="row">
        <pagination 
                    :current-page="currentPage"
                    :total-pages="totalPages" @click="getPageOnClick">
        </pagination>
      </div>
  </div>
</template>
<script>
import Pagination from "components/Pagination"
import LeadItem from "components/CRM/LeadItem"
import LeadItemDetails from "components/CRM/LeadItemDetails"

import {mapGetters, mapActions} from "vuex"
export default {
  name:"CRM_Results",
  components:{
    Pagination,
    LeadItem,
    LeadItemDetails
  },

  data() {
    return {
      lead_items_detailed_idx:[],
    }
  },

  computed : {
    ...mapGetters("crm", ["is_fetching","leads","search_params","page_of_leads"]),

    paginationNeeded () {
      return this.leads.last_page > 1
    },

    totalPages() {
      return this.leads.last_page
    },

    currentPage(){
      return this.leads.current_page - 1
    },

  },

  methods :{
    ...mapActions("crm", [
      "fetch_all_leads",
      "set_fetching_state",
      "set_search_params",
      "get_user_info",
    ]),

    toggle_details(idx, flag){
      if (flag)
        this.lead_items_detailed_idx.push(idx)
      else {
        this.lead_items_detailed_idx = _.filter(this.lead_items_detailed_idx, lididx => lididx != idx)
      }
    },

    is_toggled(idx)
    {
      var found = _.find(this.lead_items_detailed_idx, lididx => lididx == idx)
      return found != undefined
    },

    fetch()
    {
      this.set_fetching_state(true)
      this.set_search_params(this.search_params)
      this.fetch_all_leads(this.search_params)
                  .then(() => this.set_fetching_state(false))
    },

    getPageOnClick(event){
      if (event + 1 <= this.totalPages && !this.is_fetching)
      {
        this.set_search_params({page:event+1})
        this.fetch()
      }
    },

  }

}
</script>

<style scoped >
  .results-block {
    padding: 20px;
    background-color: white;
  }

  .result-head {
    display: flex;
  }

  .add-button-container {
    margin-left: auto;
    margin-top: 10px;
  }

  .lead-item {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// client/components/CRM/Results.vue